var Platform = {
  type: 'js',
  platform: 'browser'
};

module.exports = Platform;



// WEBPACK FOOTER //
// ./node_modules/platform-specific/index.js